import { POST_MESSAGE_IDENTIFIER } from '@cp/constants/Global';
import exp from 'constants';
import store from '@cp/src/store';

const sendAgentAvailabilityStatusToSlash = (status: boolean) => {
  window.postMessage({
    type: POST_MESSAGE_IDENTIFIER.SEND_AGENT_BREAK_STATUS,
    data: {
      isAgentOnline: status
    }
  });
};

export default sendAgentAvailabilityStatusToSlash;
